import { createContext } from 'react'
import type { ChatMessage } from '../../shared/types/chat'

export interface DebugData {
  conversationId: string | null
  messages: ChatMessage[]
}

export interface DebugContextValue {
  data: DebugData
  setDebugData: (conversationId: string | null, messages: ChatMessage[]) => void
}

export const DebugCtx = createContext<DebugContextValue | null>(null)
